import { atom } from "jotai";
import { atomWithStorage } from "jotai/utils";

import { type SendTransactionAppRequest } from "@/utils/tonConnect/hooks";
import { type AccountConnection, type TonConnectParams } from "@/utils/tonConnect/types";

interface ConnectionsStorage {
  [accountAddress: string]: AccountConnection[];
}

export const connectionsAtom = atomWithStorage<ConnectionsStorage>("@arc/main/connections", {}, undefined, {
  getOnInit: true,
});

export const lastEventIdAtom = atomWithStorage<string | undefined>("@arc/main/lastEventId", undefined, undefined, {
  getOnInit: true,
});

export const allConnectionsAtom = atom((get) => Object.values(get(connectionsAtom)).flat());

// NOTE: Storing data for TonConnect Connection Modal
export const tonConnectParamsAtom = atom<TonConnectParams | null>(null);

export const transactionsQueueAtom = atom<SendTransactionAppRequest[]>([]);
